import React from "react"
import DynamicInputs from "@components/objects/DynamicInputs/DynamicInputs"

const FormTestimonials = ({ data, handleChangeDynamic }) => (
  <section>
    <div>
      <h3>Testimonials</h3>
      <p>
        Please add some of your customers' testimonials, these will be displayed on your profile
        page
      </p>
      <DynamicInputs
        handlechange={(e) => handleChangeDynamic(e, "testimonials")}
        buttonLabel="Add Testimonial"
        stateName="testimonials"
        title="Testimonials"
        className="dynamic-input"
        value={data.testimonials.map((el) => el.attributes)}
        inputFields={[
          {
            className: "testimonialname",
            label: "Name",
            inputType: "text",
          },
          {
            className: "testimonialtext",
            label: "Testimonial",
            inputType: "textarea",
          },
        ]}
      />
    </div>
  </section>
)

export default FormTestimonials
